import { getBoundingBox } from "../../utils/dom";

export default class Content {
	constructor(el) {
		this.el = el;

		this.init();
	}

	init() {
		this.container = this.el.querySelector(".c-card__content-container");
		this.button = this.el.querySelector(".c-card__button");
		this.height = this.getHeight();
	}

	getHeight() {
		return getBoundingBox(this.container, ["height"]);
	}

	handleResize() {
		this.update();
	}

	open() {
		this.update();

		if (this.button) {
			this.button.setAttribute("tabindex", "0");
		}
	}

	close() {
		this.el.style.height = 0;

		if (this.button) {
			this.button.setAttribute("tabindex", "-1");
		}
	}

	update() {
		this.height = this.getHeight();
		this.el.style.height = `${this.height}px`;
	}
}
